import { Injectable } from "@angular/core";
import { DSRESTClient } from "../shared/communication-objects/restclient.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LogService } from "./log.service";

@Injectable()
export class UsageService {
  getTankUsageAnomalies(params: any) {
    return this.restClient
      .getDirect<any>(
        `${this.apiUrl}/getTankUsageAnomalies/${params?.tankId}?frmDt=${params?.fromDate}&toDt=${params?.toDate}&orgId=${params?.orgId}&incCO=${params?.includeChildOrganizations}`
      )
      .pipe(
        tap((results) => {
          this.logger.log("getTankUsageAnomalies", params, results);
        })
      );
  }

  private readonly apiUrl: string = "Usage";

  constructor(private restClient: DSRESTClient, private logger: LogService) {}

  get(params: any): Observable<any> {
    return this.restClient.post(this.apiUrl, params);
  }

  getOrgDailyUsage(params: any): Observable<any> {
    return this.restClient
      .getDirect<any>(
        `${this.apiUrl}/getOrgDailyUsage/${params?.orgId}?frmDt=${params?.fromDate}&toDt=${params?.toDate}&incCO=${params?.includeChildOrganizations}`
      )
      .pipe(
        tap((results) => {
          this.logger.log("OrgDailyUsageChart", params, results);
        })
      );
  }

  getTankDailyUsageChartDataAsync(tankId: number): Observable<any> {
    const apiResponse = this.restClient.getDirect<any>(
      `${this.apiUrl}/getTankDailyUsageChartDataAsync/${tankId}`
    );
    return apiResponse.pipe(
      tap((response) =>
        this.logger.log('getTankDailyUsageChartDataAsync Response', response)
      )
    );
  }
}
